import * as React from 'react';
import { SVGProps } from 'react';

const IconDocFilledSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 2c0-.5.5-1 1-1h3.138c.248 0 .373 0 .48.044.108.045.198.134.378.315l2.669 2.738c.195.194.29.289.335.403.043.108.043.232.043.475L10 10c0 .5-.5 1-1 1H3c-.5 0-1-.5-1-1V2zm7 2.5L6.5 2v2a.5.5 0 0 0 .5.5h2zM3.5 6H8v1H3.5V6zm0 3V8H7v1H3.5z"
    />
  </svg>
);
export default IconDocFilledSizeXs;
